export default __webpack_public_path__ + "static/t-shirt-4c5651b7c95cd5b3e0a7609034b7cb89.jpg";